import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FullPageLayout from "../../components/FullPageLayout";
import blankPic from "../../assets/images/blank_avatar.png";
import AppView from "../../views/MyApps/AppView";
import MyAppsModal from "../../views/MyApps/MyAppsModal";
import * as customerAppsActions from "../../redux/actions/customerAppsActions";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import i18n from "../../i18n";

const createData = app => {
  return {
    title: app.name,
    img: app.appImage || blankPic,
    url: app.url,
    id: app.id,
    permanent: app.permanent
  };
};

const menuItem = [
  {
    label: "Edit App",
    value: "editApp"
  },
  {
    label: "Delete app",
    value: "deleteApp"
  }
];

const appsContainerSize = {
  xs: 12,
  sm: 6,
  md: 3,
  xl: 2
};

class LearningCenterMyApps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAppModalView: false,
      modalTitle: "Add an App",
      appImg: null,
      appImgUrl: blankPic,
      appName: "",
      appUrl: "",
      appId: null
    };

    this.onMenuItemClick = this.onMenuItemClick.bind(this);
  }

  componentWillMount() {
    this.props.customerAppsActions.fetchCustomerApps();
  }

  onAppSave = appObj => {
    if (this.state.appImg) {
      appObj.image = this.state.appImg;
    }

    if (appObj.image) {
      this.props.customerAppsActions.createCustomerApp(appObj, () => {
        this.onAppModalClose();

        alert(i18n.t("learningCenterMyApps.appCreatedSuccessfully"));
      });
    } else {
      alert(i18n.t("learningCenterMyApps.appImageOrIconRequired"));
    }
  };

  onAppUpdate = (appObj, appId) => {
    if (this.state.appImg) {
      appObj.image = this.state.appImg;
    }

    this.props.customerAppsActions.updateCustomerApp(appObj, appId, () => {
      this.onAppModalClose();
      alert(i18n.t("learningCenterMyApps.appSaveSuccess"));
    });
  };

  onMenuItemClick(option, data) {
    switch (option.value) {
      case "editApp":
        this.setState({
          isAppModalView: true,
          modalTitle: "Edit an App",
          appImgUrl: data.img,
          appName: data.title,
          appUrl: data.url,
          appId: data.id
        });

        return;
      case "deleteApp":
        if (
          window.confirm(
            i18n.t("learningCenterMyApps.confirmAppDelete", {
              title: data.title
            })
          )
        ) {
          console.log("result");
          this.props.customerAppsActions.deleteCustomerApp(data.id, () => {
            alert(i18n.t("learningCenterMyApps.appDeleteSuccess"));
          });
        }

        return;

      default:
        return;
    }
  }

  onAddAppClick = () => {
    this.setState({
      isAppModalView: true,
      modalTitle: "Add an App",
      appImgUrl: blankPic,
      appImg: null,
      appName: "",
      appUrl: "",
      appId: null
    });
  };

  onAppModalClose = () => {
    this.setState({ isAppModalView: false });
  };

  onImageUpload = event => {
    let target = event.target;
    if (target.files && target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          var img = new Image();
          img.src = reader.result;

          img.onload = () => {
            if (img.width > 2048 || img.height > 2048) {
              alert(i18n.t("learningCenterMyApps.imgDoesntMeetSpecs"));
              return;
            } else {
              this.setState({
                appImgUrl: reader.result,
                appImg: target.files[0]
              });
            }
          };
        },
        false
      );
      reader.readAsDataURL(target.files[0]);
    }
  };

  getAppModal = () => {
    const { isAppModalView, modalTitle, appName, appUrl, appId } = this.state;
    return (
      <MyAppsModal
        title={modalTitle}
        open={isAppModalView}
        onClose={this.onAppModalClose}
        imgSrc={this.state.appImgUrl}
        onImgUpload={this.onImageUpload}
        onAppSave={this.onAppSave}
        onAppUpdate={this.onAppUpdate}
        appName={appName}
        appUrl={appUrl}
        id={appId}
      />
    );
  };

  render() {
    const { loading, fetched, apps } = this.props.customerAppsState;
    let user = this.props.userState;

    if (!fetched || loading || user.loading) {
      return (
        <FullPageLayout title={"My Apps"}>
          <LoadingSpinner visible={this.state.showLoader} />
        </FullPageLayout>
      );
    }
    if (fetched && !loading && !user.loading) {
      let data = apps.map(function(app) {
        return createData(app);
      });
      return (
        <FullPageLayout title={"My Apps"}>
          <AppView
            user={user.user}
            data={data}
            menuOptions={menuItem}
            onMenuItemClick={this.onMenuItemClick}
            onAddAppClick={this.onAddAppClick}
            appsContainerSize={appsContainerSize}
          />
          {this.state.isAppModalView && this.getAppModal()}
        </FullPageLayout>
      );
    }
  }
}

const mapStateToProps = state => ({
  customerAppsState: state.customerAppsState,
  userState: state.userState
});

const mapDispatchToProps = dispatch => ({
  customerAppsActions: bindActionCreators(customerAppsActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningCenterMyApps);
